var next_dynamic_table_page = 1;
var saved_attribute_id = 0;
var block_called = 0;
var dyanmic_table_callback = null;
//Handler function to check if the scroll is near the bottom
function check_if_scrolled_to_bottom(e){
    if ( e.target.scrollTop + e.target.offsetHeight > e.target.scrollHeight * 0.8 ) {
        if(block_called==next_dynamic_table_page)
            return;
        else
            block_called = next_dynamic_table_page;
        load_table_data(false);
      }
}

// Add the event listener with a removable handler
function add_event_listener_scroll_bottom(element) {
  element.addEventListener(
    "scroll",check_if_scrolled_to_bottom, { passive: false }
  );
}

function load_table_data(attribute,callback, options = null) {

    //Save the attribute Id or use the cached one
    if(!attribute && !saved_attribute_id)
        return;
    if(!saved_attribute_id)
        saved_attribute_id = attribute;
    if(callback)
        dyanmic_table_callback = callback;

    const params = new URLSearchParams({
        fetch_clone: !!options?.fetch_clone,
        is_dev: !!options?.is_dev
    }).toString();

    //Fetches partial response
    fetch(`/catalog/attributes/list_product_attributes/${saved_attribute_id}/${next_dynamic_table_page}/?${params}`)
    .then(response => response.json())
    .then(function (data) {
        //If its the last page, remove the listener 
        if(data.isLast){
            document.getElementById("dynamic_table_div").removeEventListener("scroll",check_if_scrolled_to_bottom);
        }
        //If is a new page, insert it
        if(next_dynamic_table_page < data.next_page){
            next_dynamic_table_page = data.next_page;
            document.getElementById("attr_rows").insertAdjacentHTML('beforeend',data.elements);
        }
        if(callback || dyanmic_table_callback)
            dyanmic_table_callback();
    })
    .catch(function (err) {
    console.warn("Couldn't fetch dynamic table data.", err);
    });
}

am.$(function () {
    //Adds the event listener to the dynamic table
    const dynamic_table_div = document.getElementById("dynamic_table_div")
    if (dynamic_table_div) {
        add_event_listener_scroll_bottom(dynamic_table_div);
    }
});